import { Children, cloneElement, isValidElement } from "react";
function _map(children, fn, maxDepth, depth) {
    return Children.map(children, (child) => {
        if (isValidElement(child) && child.props.children && depth !== maxDepth) {
            child = cloneElement(child, {
                children: _map(child.props.children, fn, maxDepth, depth + 1),
            });
        }
        return fn(child);
    });
}
export function map(children, fn, options = {}) {
    var _a;
    const maxDepth = (_a = options["maxDepth"]) !== null && _a !== void 0 ? _a : -1;
    return _map(children, fn, maxDepth, 0);
}
